// extracted by mini-css-extract-plugin
export var bottomLine = "footerstyles-module--bottomLine--66462";
export var bottomRow = "footerstyles-module--bottomRow--b7e7c";
export var column__name = "footerstyles-module--column__name--98aeb";
export var followUs = "footerstyles-module--followUs--318f3";
export var footerCol = "footerstyles-module--footerCol--c6afa";
export var footerCol__links = "footerstyles-module--footerCol__links--52637";
export var footerCopyright = "footerstyles-module--footerCopyright--bd2aa";
export var footerLogo = "footerstyles-module--footerLogo--07e1b";
export var footerMenu = "footerstyles-module--footerMenu--fbe56";
export var footerMenu__link = "footerstyles-module--footerMenu__link--8c39f";
export var footerMobileMenu = "footerstyles-module--footerMobileMenu--976b6";
export var footerWrapper = "footerstyles-module--footerWrapper--88933";
export var footer__menu__links = "footerstyles-module--footer__menu__links--0adc1";
export var langSelect = "footerstyles-module--langSelect--89a23";
export var mobileFollowUs = "footerstyles-module--mobileFollowUs--e9a69";
export var mobileFooter = "footerstyles-module--mobileFooter--690b6";
export var mobileFooterWrapper = "footerstyles-module--mobileFooterWrapper--76514";
export var mobileLangSelect = "footerstyles-module--mobileLangSelect--9764a";
export var mobileSocialLinks = "footerstyles-module--mobileSocialLinks--ae452";
export var siteFooter = "footerstyles-module--siteFooter--8714b";
export var socialLinks = "footerstyles-module--socialLinks--7b2ad";
export var subscribe = "footerstyles-module--subscribe--d9fff";
export var subscribe__button = "footerstyles-module--subscribe__button--f1d8b";
export var subscribe__input = "footerstyles-module--subscribe__input--afde7";